import React from 'react';
import Input from 'components/input';
import styles from '../../products.module.scss';
import cx from 'classname';
import CustomSelect from 'components/common/CustomSelect';

const SingleProduct = (props) => {
  const {
    handleChange,
    data,
    setData,
    money,
    setMoney,
    errors,
    register,
    amountType,
  } = props;

  return (
    <div data-testid="single plan">
      <div className={styles.rowCreate}>
        <div className={cx(styles.columnCreate, styles.inputLeft)}>
          <CustomSelect
            label="Select product amount"
            options={[
              {
                text: 'FIXED',
                value: 'FIXED',
              },

              {
                text: 'DYNAMIC',
                value: 'DYNAMIC',
              },
            ]}
            variant="blue"
            handleClick={(item) =>
              setData({ ...data, amountType: item.value, amount: null })
            }
            defaultValue={amountType === 'single' && data?.amountType}
          />
        </div>
        <div className={cx(styles.columnCreate, styles.inputRight)}>
          {data?.amountType === 'FIXED' ? (
            <Input
              label="Enter amount"
              type="number"
              placeholder="Enter amount here"
              autoFocus
              name="amount"
              value={data.amount}
              onChange={handleChange}
              ref={register({
                required: 'Amount is required',
                min: {
                  value: 100,
                  message: 'Amount cannot be less than 100',
                },
                max: {
                  value: 1000000,
                  message: 'Amount cannot be greaater than 1,000,000',
                },
              })}
              error={errors && errors['amount']?.message}
              data-testid="amount"
            />
          ) : null}
        </div>
      </div>
      {data?.amountType === 'DYNAMIC' ? (
        <div className={styles.rowCreate}>
          <div className={cx(styles.columnCreate, styles.inputLeft)}>
            <Input
              label="Minimum amount"
              type="number"
              placeholder="Enter minimum amount here"
              autoFocus
              name="min"
              value={money?.min}
              onChange={(e) => setMoney({ ...money, min: e.target.value })}
              data-testid="dynamic-min"
            />
          </div>
          <div className={cx(styles.columnCreate, styles.inputRight)}>
            <Input
              label="Maximum amount"
              type="number"
              placeholder="Enter maximum amount here"
              autoFocus
              name="max"
              value={money?.max}
              onChange={(e) => setMoney({ ...money, max: e.target.value })}
              data-testid="dynamic-max"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SingleProduct;
